var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      class: _vm.$style.dialog,
      on: { cancel: _vm.$formCancelHandler, submit: _vm.$formSubmitHandler },
    },
    [
      _c("span", { attrs: { slot: "header" }, slot: "header" }, [
        _c("div", [_vm._v("Create New RFP")]),
      ]),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody",
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          _c(
            "rb-input",
            {
              attrs: {
                "for-id": "accountId",
                error: _vm.$showError("accountId"),
              },
            },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("Select Company"),
              ]),
              _c("rb-select-new", {
                staticClass: "simple",
                attrs: {
                  id: "accountId",
                  name: "accountId",
                  options: _vm.accountOptions,
                },
                model: {
                  value: _vm.data.accountId,
                  callback: function ($$v) {
                    _vm.$set(_vm.data, "accountId", $$v)
                  },
                  expression: "data.accountId",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultFooter",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "button",
            {
              staticClass: "rbButton",
              class: _vm.$style.left,
              attrs: { type: "button" },
              on: { click: _vm.createCompany },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("business")]),
              _vm._v(" New Company "),
            ]
          ),
          _c(
            "button",
            {
              staticClass: "rbButton",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" Cancel ")]
          ),
          _c(
            "button",
            {
              staticClass: "rbButton mainButton",
              attrs: { disabled: !_vm.data.accountId },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("save")]),
              _vm._v(" Create RFP "),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }